<template><div></div></template>

<script>
export default {
  props: {
    currentIndex: Number,
  },
  methods: {
    validate() {
      this.$emit('validate', { isValid: true, currentIndex: this.currentIndex })
    },
  },
}
</script>
